import SimpleTable from "../../components/Table";

export class TableStrategy {
  constructor(props) {
    this.props = props;
  }

  render() {
    return (
      <SimpleTable
        data={this.props.data}
        darkMode={this.props.darkMode}
        title={this.props.title}
      />
    );
  }
}
